// Letter shuffle for short English UI labels (brand name + header nav links) only.
// Runs once on page load (left to right, staggered) and on hover / focus.
// Never touches Japanese text or post titles. Off under prefers-reduced-motion (checked on every run).
(() => {
  // read at the time of each action, so a change while the page is open takes effect
  const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  const GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const TOTAL_FRAMES = 14;
  const FRAME_MS = 34;

  const shuffle = (el) => {
    if (el.dataset.shuffling || reduceMotion()) return;
    el.dataset.text = el.dataset.text || el.textContent;
    const text = () => el.dataset.text; // read on every frame: a label change mid-shuffle is respected
    el.style.width = `${el.getBoundingClientRect().width}px`; // lock the width so the layout stays still
    el.dataset.shuffling = '1';
    let frame = 0;
    const tick = () => {
      frame++;
      const settled = Math.floor((frame / TOTAL_FRAMES) * text().length);
      el.textContent = [...text()]
        .map((ch, i) => (i < settled || ch === ' ' ? ch : GLYPHS[(Math.random() * GLYPHS.length) | 0]))
        .join('');
      if (frame < TOTAL_FRAMES) {
        setTimeout(tick, FRAME_MS); // timers, not rAF: rAF pauses in hidden tabs
      } else {
        el.textContent = text();
        el.style.width = '';
        delete el.dataset.shuffling;
      }
    };
    tick();
  };

  const init = () => {
    const targets = [...document.querySelectorAll('.l-brand__name, .l-nav a')];
    targets.forEach((el) => {
      el.dataset.text = el.textContent;
      el.addEventListener('mouseenter', () => shuffle(el));
      el.addEventListener('focus', () => shuffle(el));
    });
    // Once on load, left to right. A page opened in a background tab waits until it is shown.
    const shuffleAll = () => targets.forEach((el, i) => setTimeout(() => shuffle(el), 120 + i * 60));
    if (document.visibilityState === 'visible') {
      shuffleAll();
    } else {
      document.addEventListener('visibilitychange', function onShow() {
        if (document.visibilityState !== 'visible') return;
        document.removeEventListener('visibilitychange', onShow);
        shuffleAll();
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
